module.exports = __webpack_public_path__ + "img/icon-coin-cancel.2a426f8a.svg";